/**
 * Dynamic color mapping utility for chart styling
 * Provides multiple color palettes for user selection
 */

// Color Palette Sets - 10 colors each
const COLOR_PALETTES = {
  // Mixed vibrant colors (default)
  vibrant: [
    { bg: 'rgba(255, 99, 132, 0.6)', border: 'rgba(255, 99, 132, 1)' }, // Red
    { bg: 'rgba(54, 162, 235, 0.6)', border: 'rgba(54, 162, 235, 1)' }, // Blue
    { bg: 'rgba(255, 206, 86, 0.6)', border: 'rgba(255, 206, 86, 1)' }, // Yellow
    { bg: 'rgba(75, 192, 192, 0.6)', border: 'rgba(75, 192, 192, 1)' }, // Teal
    { bg: 'rgba(153, 102, 255, 0.6)', border: 'rgba(153, 102, 255, 1)' }, // Purple
    { bg: 'rgba(255, 159, 64, 0.6)', border: 'rgba(255, 159, 64, 1)' }, // Orange
    { bg: 'rgba(199, 199, 199, 0.6)', border: 'rgba(199, 199, 199, 1)' }, // Gray
    { bg: 'rgba(83, 102, 255, 0.6)', border: 'rgba(83, 102, 255, 1)' }, // Indigo
    { bg: 'rgba(255, 99, 255, 0.6)', border: 'rgba(255, 99, 255, 1)' }, // Magenta
    { bg: 'rgba(99, 255, 132, 0.6)', border: 'rgba(99, 255, 132, 1)' }, // Light Green
  ],

  // Blue shades
  blueShades: [
    { bg: 'rgba(13, 71, 161, 0.6)', border: 'rgba(13, 71, 161, 1)' }, // Dark Blue
    { bg: 'rgba(25, 118, 210, 0.6)', border: 'rgba(25, 118, 210, 1)' }, // Medium Blue
    { bg: 'rgba(33, 150, 243, 0.6)', border: 'rgba(33, 150, 243, 1)' }, // Blue
    { bg: 'rgba(66, 165, 245, 0.6)', border: 'rgba(66, 165, 245, 1)' }, // Light Blue
    { bg: 'rgba(100, 181, 246, 0.6)', border: 'rgba(100, 181, 246, 1)' }, // Lighter Blue
    { bg: 'rgba(144, 202, 249, 0.6)', border: 'rgba(144, 202, 249, 1)' }, // Very Light Blue
    { bg: 'rgba(187, 222, 251, 0.6)', border: 'rgba(187, 222, 251, 1)' }, // Pale Blue
    { bg: 'rgba(227, 242, 253, 0.6)', border: 'rgba(227, 242, 253, 1)' }, // Very Pale Blue
    { bg: 'rgba(3, 169, 244, 0.6)', border: 'rgba(3, 169, 244, 1)' }, // Cyan Blue
    { bg: 'rgba(0, 188, 212, 0.6)', border: 'rgba(0, 188, 212, 1)' }, // Cyan
  ],

  // Green shades
  greenShades: [
    { bg: 'rgba(27, 94, 32, 0.6)', border: 'rgba(27, 94, 32, 1)' }, // Dark Green
    { bg: 'rgba(46, 125, 50, 0.6)', border: 'rgba(46, 125, 50, 1)' }, // Medium Green
    { bg: 'rgba(67, 160, 71, 0.6)', border: 'rgba(67, 160, 71, 1)' }, // Green
    { bg: 'rgba(102, 187, 106, 0.6)', border: 'rgba(102, 187, 106, 1)' }, // Light Green
    { bg: 'rgba(129, 199, 132, 0.6)', border: 'rgba(129, 199, 132, 1)' }, // Lighter Green
    { bg: 'rgba(165, 214, 167, 0.6)', border: 'rgba(165, 214, 167, 1)' }, // Very Light Green
    { bg: 'rgba(200, 230, 201, 0.6)', border: 'rgba(200, 230, 201, 1)' }, // Pale Green
    { bg: 'rgba(232, 245, 233, 0.6)', border: 'rgba(232, 245, 233, 1)' }, // Very Pale Green
    { bg: 'rgba(76, 175, 80, 0.6)', border: 'rgba(76, 175, 80, 1)' }, // Material Green
    { bg: 'rgba(139, 195, 74, 0.6)', border: 'rgba(139, 195, 74, 1)' }, // Light Material Green
  ],

  // Red shades
  redShades: [
    { bg: 'rgba(183, 28, 28, 0.6)', border: 'rgba(183, 28, 28, 1)' }, // Dark Red
    { bg: 'rgba(211, 47, 47, 0.6)', border: 'rgba(211, 47, 47, 1)' }, // Medium Red
    { bg: 'rgba(229, 57, 53, 0.6)', border: 'rgba(229, 57, 53, 1)' }, // Red
    { bg: 'rgba(239, 83, 80, 0.6)', border: 'rgba(239, 83, 80, 1)' }, // Light Red
    { bg: 'rgba(244, 117, 96, 0.6)', border: 'rgba(244, 117, 96, 1)' }, // Lighter Red
    { bg: 'rgba(248, 144, 114, 0.6)', border: 'rgba(248, 144, 114, 1)' }, // Very Light Red
    { bg: 'rgba(250, 172, 140, 0.6)', border: 'rgba(250, 172, 140, 1)' }, // Pale Red
    { bg: 'rgba(252, 204, 177, 0.6)', border: 'rgba(252, 204, 177, 1)' }, // Very Pale Red
    { bg: 'rgba(255, 87, 34, 0.6)', border: 'rgba(255, 87, 34, 1)' }, // Orange Red
    { bg: 'rgba(255, 112, 67, 0.6)', border: 'rgba(255, 112, 67, 1)' }, // Light Orange Red
  ],

  // Purple shades
  purpleShades: [
    { bg: 'rgba(74, 20, 140, 0.6)', border: 'rgba(74, 20, 140, 1)' }, // Dark Purple
    { bg: 'rgba(106, 27, 154, 0.6)', border: 'rgba(106, 27, 154, 1)' }, // Medium Purple
    { bg: 'rgba(142, 36, 170, 0.6)', border: 'rgba(142, 36, 170, 1)' }, // Purple
    { bg: 'rgba(171, 71, 188, 0.6)', border: 'rgba(171, 71, 188, 1)' }, // Light Purple
    { bg: 'rgba(186, 104, 200, 0.6)', border: 'rgba(186, 104, 200, 1)' }, // Lighter Purple
    { bg: 'rgba(206, 147, 216, 0.6)', border: 'rgba(206, 147, 216, 1)' }, // Very Light Purple
    { bg: 'rgba(225, 190, 231, 0.6)', border: 'rgba(225, 190, 231, 1)' }, // Pale Purple
    { bg: 'rgba(243, 229, 245, 0.6)', border: 'rgba(243, 229, 245, 1)' }, // Very Pale Purple
    { bg: 'rgba(156, 39, 176, 0.6)', border: 'rgba(156, 39, 176, 1)' }, // Material Purple
    { bg: 'rgba(171, 71, 188, 0.6)', border: 'rgba(171, 71, 188, 1)' }, // Light Material Purple
  ],

  // Colorful mix (bright and diverse)
  colorfulMix: [
    { bg: 'rgba(244, 67, 54, 0.6)', border: 'rgba(244, 67, 54, 1)' }, // Red
    { bg: 'rgba(233, 30, 99, 0.6)', border: 'rgba(233, 30, 99, 1)' }, // Pink
    { bg: 'rgba(156, 39, 176, 0.6)', border: 'rgba(156, 39, 176, 1)' }, // Purple
    { bg: 'rgba(103, 58, 183, 0.6)', border: 'rgba(103, 58, 183, 1)' }, // Deep Purple
    { bg: 'rgba(63, 81, 181, 0.6)', border: 'rgba(63, 81, 181, 1)' }, // Indigo
    { bg: 'rgba(33, 150, 243, 0.6)', border: 'rgba(33, 150, 243, 1)' }, // Blue
    { bg: 'rgba(3, 169, 244, 0.6)', border: 'rgba(3, 169, 244, 1)' }, // Light Blue
    { bg: 'rgba(0, 188, 212, 0.6)', border: 'rgba(0, 188, 212, 1)' }, // Cyan
    { bg: 'rgba(0, 150, 136, 0.6)', border: 'rgba(0, 150, 136, 1)' }, // Teal
    { bg: 'rgba(76, 175, 80, 0.6)', border: 'rgba(76, 175, 80, 1)' }, // Green
  ],

  // Warm colors
  warmColors: [
    { bg: 'rgba(255, 183, 77, 0.6)', border: 'rgba(255, 183, 77, 1)' }, // Amber
    { bg: 'rgba(255, 152, 0, 0.6)', border: 'rgba(255, 152, 0, 1)' }, // Orange
    { bg: 'rgba(255, 87, 34, 0.6)', border: 'rgba(255, 87, 34, 1)' }, // Deep Orange
    { bg: 'rgba(244, 67, 54, 0.6)', border: 'rgba(244, 67, 54, 1)' }, // Red
    { bg: 'rgba(233, 30, 99, 0.6)', border: 'rgba(233, 30, 99, 1)' }, // Pink
    { bg: 'rgba(194, 24, 91, 0.6)', border: 'rgba(194, 24, 91, 1)' }, // Dark Pink
    { bg: 'rgba(156, 39, 176, 0.6)', border: 'rgba(156, 39, 176, 1)' }, // Purple
    { bg: 'rgba(255, 193, 7, 0.6)', border: 'rgba(255, 193, 7, 1)' }, // Yellow
    { bg: 'rgba(255, 235, 59, 0.6)', border: 'rgba(255, 235, 59, 1)' }, // Light Yellow
    { bg: 'rgba(255, 241, 118, 0.6)', border: 'rgba(255, 241, 118, 1)' }, // Very Light Yellow
  ],

  // Cool colors
  coolColors: [
    { bg: 'rgba(63, 81, 181, 0.6)', border: 'rgba(63, 81, 181, 1)' }, // Indigo
    { bg: 'rgba(33, 150, 243, 0.6)', border: 'rgba(33, 150, 243, 1)' }, // Blue
    { bg: 'rgba(3, 169, 244, 0.6)', border: 'rgba(3, 169, 244, 1)' }, // Light Blue
    { bg: 'rgba(0, 188, 212, 0.6)', border: 'rgba(0, 188, 212, 1)' }, // Cyan
    { bg: 'rgba(0, 150, 136, 0.6)', border: 'rgba(0, 150, 136, 1)' }, // Teal
    { bg: 'rgba(76, 175, 80, 0.6)', border: 'rgba(76, 175, 80, 1)' }, // Green
    { bg: 'rgba(139, 195, 74, 0.6)', border: 'rgba(139, 195, 74, 1)' }, // Light Green
    { bg: 'rgba(205, 220, 57, 0.6)', border: 'rgba(205, 220, 57, 1)' }, // Lime
    { bg: 'rgba(103, 58, 183, 0.6)', border: 'rgba(103, 58, 183, 1)' }, // Deep Purple
    { bg: 'rgba(121, 85, 72, 0.6)', border: 'rgba(121, 85, 72, 1)' }, // Brown
  ],

  // Pastel colors
  pastelColors: [
    { bg: 'rgba(255, 205, 210, 0.6)', border: 'rgba(255, 205, 210, 1)' }, // Pastel Red
    { bg: 'rgba(248, 187, 208, 0.6)', border: 'rgba(248, 187, 208, 1)' }, // Pastel Pink
    { bg: 'rgba(225, 190, 231, 0.6)', border: 'rgba(225, 190, 231, 1)' }, // Pastel Purple
    { bg: 'rgba(209, 196, 233, 0.6)', border: 'rgba(209, 196, 233, 1)' }, // Pastel Deep Purple
    { bg: 'rgba(197, 202, 233, 0.6)', border: 'rgba(197, 202, 233, 1)' }, // Pastel Indigo
    { bg: 'rgba(187, 222, 251, 0.6)', border: 'rgba(187, 222, 251, 1)' }, // Pastel Blue
    { bg: 'rgba(178, 235, 242, 0.6)', border: 'rgba(178, 235, 242, 1)' }, // Pastel Light Blue
    { bg: 'rgba(178, 223, 219, 0.6)', border: 'rgba(178, 223, 219, 1)' }, // Pastel Cyan
    { bg: 'rgba(200, 230, 201, 0.6)', border: 'rgba(200, 230, 201, 1)' }, // Pastel Green
    { bg: 'rgba(220, 237, 200, 0.6)', border: 'rgba(220, 237, 200, 1)' }, // Pastel Light Green
  ],

  // Professional colors
  professional: [
    { bg: 'rgba(55, 71, 79, 0.6)', border: 'rgba(55, 71, 79, 1)' }, // Blue Grey
    { bg: 'rgba(69, 90, 100, 0.6)', border: 'rgba(69, 90, 100, 1)' }, // Medium Blue Grey
    { bg: 'rgba(84, 110, 122, 0.6)', border: 'rgba(84, 110, 122, 1)' }, // Light Blue Grey
    { bg: 'rgba(120, 144, 156, 0.6)', border: 'rgba(120, 144, 156, 1)' }, // Very Light Blue Grey
    { bg: 'rgba(38, 50, 56, 0.6)', border: 'rgba(38, 50, 56, 1)' }, // Dark Blue Grey
    { bg: 'rgba(96, 125, 139, 0.6)', border: 'rgba(96, 125, 139, 1)' }, // Medium Light Blue Grey
    { bg: 'rgba(144, 164, 174, 0.6)', border: 'rgba(144, 164, 174, 1)' }, // Light Medium Blue Grey
    { bg: 'rgba(176, 190, 197, 0.6)', border: 'rgba(176, 190, 197, 1)' }, // Very Light Medium Blue Grey
    { bg: 'rgba(207, 216, 220, 0.6)', border: 'rgba(207, 216, 220, 1)' }, // Almost White Blue Grey
    { bg: 'rgba(236, 239, 241, 0.6)', border: 'rgba(236, 239, 241, 1)' }, // Very Pale Blue Grey
  ]
};

// Palette metadata for UI - grouped by type
const PALETTE_OPTIONS = [
  // Single-shade palettes
  { 
    id: 'blueShades', 
    name: 'Blues', 
    type: 'single-shade',
    description: '10 shades of blue',
    preview: ['rgba(13, 71, 161, 1)', 'rgba(33, 150, 243, 1)', 'rgba(100, 181, 246, 1)', 'rgba(187, 222, 251, 1)']
  },
  { 
    id: 'greenShades', 
    name: 'Greens', 
    type: 'single-shade',
    description: '10 shades of green',
    preview: ['rgba(27, 94, 32, 1)', 'rgba(67, 160, 71, 1)', 'rgba(129, 199, 132, 1)', 'rgba(200, 230, 201, 1)']
  },
  { 
    id: 'redShades', 
    name: 'Reds', 
    type: 'single-shade',
    description: '10 shades of red',
    preview: ['rgba(183, 28, 28, 1)', 'rgba(229, 57, 53, 1)', 'rgba(244, 117, 96, 1)', 'rgba(250, 172, 140, 1)']
  },
  { 
    id: 'purpleShades', 
    name: 'Purples', 
    type: 'single-shade',
    description: '10 shades of purple',
    preview: ['rgba(74, 20, 140, 1)', 'rgba(142, 36, 170, 1)', 'rgba(186, 104, 200, 1)', 'rgba(225, 190, 231, 1)']
  },
  { 
    id: 'professional', 
    name: 'Professional', 
    type: 'single-shade',
    description: '10 professional grey tones',
    preview: ['rgba(38, 50, 56, 1)', 'rgba(84, 110, 122, 1)', 'rgba(144, 164, 174, 1)', 'rgba(207, 216, 220, 1)']
  },
  
  // Colorful palettes
  { 
    id: 'vibrant', 
    name: 'Vibrant', 
    type: 'colorful',
    description: '10 diverse vibrant colors',
    preview: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)']
  },
  { 
    id: 'colorfulMix', 
    name: 'Colorful Mix', 
    type: 'colorful',
    description: '10 bright diverse colors',
    preview: ['rgba(244, 67, 54, 1)', 'rgba(233, 30, 99, 1)', 'rgba(156, 39, 176, 1)', 'rgba(33, 150, 243, 1)']
  },
  { 
    id: 'warmColors', 
    name: 'Warm Colors', 
    type: 'colorful',
    description: '10 warm tones',
    preview: ['rgba(255, 183, 77, 1)', 'rgba(255, 152, 0, 1)', 'rgba(255, 87, 34, 1)', 'rgba(244, 67, 54, 1)']
  },
  { 
    id: 'coolColors', 
    name: 'Cool Colors', 
    type: 'colorful',
    description: '10 cool tones',
    preview: ['rgba(63, 81, 181, 1)', 'rgba(33, 150, 243, 1)', 'rgba(0, 188, 212, 1)', 'rgba(76, 175, 80, 1)']
  },
  { 
    id: 'pastelColors', 
    name: 'Pastels', 
    type: 'colorful',
    description: '10 soft pastel colors',
    preview: ['rgba(255, 205, 210, 1)', 'rgba(248, 187, 208, 1)', 'rgba(225, 190, 231, 1)', 'rgba(187, 222, 251, 1)']
  }
];

// Global state for current palettes
let currentBarChartPalette = 'vibrant';
let currentPieChartPalette = 'colorfulMix';
// Track whether palettes were set by user or are defaults
let userSetPalettes = {
  bar: false,
  pie: false
};
// Dynamic color assignment without predefined mappings
const dynamicColorRegistry = new Map();

/**
 * Get the current palette for a chart type
 * @param {string} chartType - 'bar' or 'pie'
 * @returns {Array} - Color palette
 */
function getCurrentPalette(chartType) {
  if (chartType === 'pie') {
    return COLOR_PALETTES[currentPieChartPalette] || COLOR_PALETTES.colorfulMix;
  }
  return COLOR_PALETTES[currentBarChartPalette] || COLOR_PALETTES.vibrant;
}

/**
 * Set the palette for a chart type
 * @param {string} chartType - 'bar' or 'pie'
 * @param {string} paletteId - Palette identifier
 * @param {boolean} isUserSelection - Whether this was a user selection (default: true)
 */
export function setPalette(chartType, paletteId, isUserSelection = true) {
  if (chartType === 'pie') {
    currentPieChartPalette = paletteId;
    userSetPalettes.pie = isUserSelection;
  } else if (chartType === 'bar') {
    currentBarChartPalette = paletteId;
    userSetPalettes.bar = isUserSelection;
  }
  // Clear dynamic registry when palette changes
  dynamicColorRegistry.clear();
}

/**
 * Get color for a label with dynamic assignment
 * @param {string} label - The data label/name
 * @param {string} type - Color type ('bg' or 'border')
 * @param {string} chartType - Chart type ('bar' or 'pie')
 * @returns {string} - Color value
 */
export function getColorByLabel(label, type = 'bg', chartType = 'bar') {
  const palette = getCurrentPalette(chartType);
  const key = `${chartType}-${label}`;
  
  // Check if we already assigned a color to this label for this chart type
  if (!dynamicColorRegistry.has(key)) {
    // Assign next available color index
    const nextIndex = dynamicColorRegistry.size % palette.length;
    dynamicColorRegistry.set(key, nextIndex);
  }
  
  const colorIndex = dynamicColorRegistry.get(key);
  return palette[colorIndex][type];
}

/**
 * Get highlighted color for a given label and type
 * @param {string} label - The data label/name
 * @param {string} type - Color type ('bg' or 'border')
 * @param {string} chartType - Chart type ('bar' or 'pie')
 * @returns {string} - Highlighted color value
 */
export function getHighlightedColorByLabel(label, type = 'bg', chartType = 'bar') {
  const baseColor = getColorByLabel(label, type, chartType);
  return type === 'bg' ? baseColor.replace('0.6', '0.9') : baseColor;
}

/**
 * Generate color array for multiple labels
 * @param {string[]} labels - Array of labels
 * @param {string} type - Color type ('bg' or 'border')
 * @param {string} chartType - Chart type ('bar' or 'pie')
 * @param {number|null} highlightedIndex - Index to highlight (optional)
 * @returns {string[]} - Array of colors
 */
export function generateColorArrayByLabels(labels, type = 'bg', chartType = 'bar', highlightedIndex = null) {
  // Handle undefined or null labels array
  if (!labels || !Array.isArray(labels) || labels.length === 0) {
    return [];
  }
  
  return labels.map((label, index) => {
    if (highlightedIndex === index) {
      return getHighlightedColorByLabel(label, type, chartType);
    }
    return getColorByLabel(label, type, chartType);
  });
}

/**
 * Generate colors for datasets based on their labels
 * @param {Object[]} datasets - Array of dataset objects with label property
 * @param {string} type - Color type ('bg' or 'border')
 * @param {string} chartType - Chart type ('bar' or 'pie')
 * @param {number|null} highlightedDatasetIndex - Dataset index to highlight (optional)
 * @param {number|null} highlightedPeriodIndex - Period index to highlight (optional)
 * @returns {Object[]} - Array of color configurations
 */
export function generateDatasetColors(datasets, type = 'bg', chartType = 'bar', highlightedDatasetIndex = null, highlightedPeriodIndex = null) {
  return datasets.map((dataset, datasetIndex) => {
    const baseColor = getColorByLabel(dataset.label, type, chartType);
    
    // If we're highlighting specific periods within datasets
    if (highlightedPeriodIndex !== null && Array.isArray(dataset.values)) {
      return dataset.values.map((_, periodIndex) => {
        if (periodIndex === highlightedPeriodIndex) {
          return getHighlightedColorByLabel(dataset.label, type, chartType);
        }
        return baseColor;
      });
    }
    
    // If we're highlighting entire datasets
    if (highlightedDatasetIndex === datasetIndex) {
      return getHighlightedColorByLabel(dataset.label, type, chartType);
    }
    
    return baseColor;
  });
}

/**
 * Get all available palette options for UI
 * @returns {Array} - Array of palette options
 */
export function getPaletteOptions() {
  return PALETTE_OPTIONS;
}

/**
 * Get current palette selections
 * @returns {Object} - Current palette IDs for each chart type
 */
export function getCurrentPaletteSelections() {
  return {
    bar: currentBarChartPalette,
    pie: currentPieChartPalette
  };
}

/**
 * Check if palettes were set by user
 * @returns {Object} - Whether each chart type was user-selected
 */
export function getUserSetPalettes() {
  return {
    bar: userSetPalettes.bar,
    pie: userSetPalettes.pie
  };
}

/**
 * Get a specific palette by ID
 * @param {string} paletteId - Palette identifier
 * @returns {Array|null} - Color palette or null if not found
 */
export function getPaletteById(paletteId) {
  return COLOR_PALETTES[paletteId] || null;
}

/**
 * Clear dynamic color assignments
 */
export function clearDynamicMappings() {
  dynamicColorRegistry.clear();
}

/**
 * Get color mapping for debugging purposes
 * @returns {Object} - Current color mappings
 */
export function getColorMappings() {
  const dynamic = Array.from(dynamicColorRegistry.entries()).map(([key, index]) => {
    const [chartType, label] = key.split('-', 2);
    const palette = getCurrentPalette(chartType);
    return {
      key,
      chartType,
      label,
      index,
      color: palette[index],
      type: 'dynamic'
    };
  });
  
  return {
    dynamic,
    currentPalettes: getCurrentPaletteSelections()
  };
}

// Export palettes for direct access if needed
export { COLOR_PALETTES };
